module.exports = __webpack_public_path__ + "static/media/intro2.017f6605.png";